'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.pubsub = exports.Topic = void 0;
var Topic;
(function (Topic) {
    Topic[Topic["WSOpen"] = 0] = "WSOpen";
    Topic[Topic["WSError"] = 1] = "WSError";
    Topic[Topic["WSClose"] = 2] = "WSClose";
    Topic[Topic["BalanceChanged"] = 3] = "BalanceChanged";
    Topic[Topic["WithdrawStatusChanged"] = 4] = "WithdrawStatusChanged";
    Topic[Topic["UserDataRequired"] = 5] = "UserDataRequired";
    Topic[Topic["KYCStatusUpdated"] = 6] = "KYCStatusUpdated";
    Topic[Topic["SessionChanged"] = 7] = "SessionChanged";
    Topic[Topic["SessionCreated"] = 8] = "SessionCreated";
    Topic[Topic["SessionDestroyed"] = 9] = "SessionDestroyed";
    Topic[Topic["SessionExpired"] = 10] = "SessionExpired";
    Topic[Topic["SessionKickedOut"] = 11] = "SessionKickedOut";
    Topic[Topic["SessionLimitationTimeReached"] = 12] = "SessionLimitationTimeReached";
    Topic[Topic["SessionSelfExclusion"] = 13] = "SessionSelfExclusion";
    Topic[Topic["SessionLoggedOut"] = 14] = "SessionLoggedOut";
    Topic[Topic["SessionGeoLocation"] = 15] = "SessionGeoLocation";
    Topic[Topic["CategoriesPublished"] = 16] = "CategoriesPublished";
    Topic[Topic["TranslationsPublished"] = 17] = "TranslationsPublished";
    Topic[Topic["UserUpdated"] = 18] = "UserUpdated";
    Topic[Topic["MaintenanceChanged"] = 19] = "MaintenanceChanged";
    Topic[Topic["AchievementUnlocked"] = 20] = "AchievementUnlocked";
    Topic[Topic["FirstDeposit"] = 21] = "FirstDeposit";
    Topic[Topic["SubsequentDeposit"] = 22] = "SubsequentDeposit";
    Topic[Topic["RewardReceived"] = 23] = "RewardReceived";
    Topic[Topic["RelicPrizeAwarded"] = 24] = "RelicPrizeAwarded";
    Topic[Topic["LeaderboardPayout"] = 25] = "LeaderboardPayout";
    Topic[Topic["DelayedReward"] = 26] = "DelayedReward";
    Topic[Topic["Message"] = 27] = "Message";
    Topic[Topic["SOWQRequested"] = 28] = "SOWQRequested";
    Topic[Topic["UserBlockStatus"] = 29] = "UserBlockStatus";
    Topic[Topic["LoyaltyPointsUpdate"] = 30] = "LoyaltyPointsUpdate";
    Topic[Topic["GameSessionSummary"] = 31] = "GameSessionSummary";
    Topic[Topic["LotbaUserSelfExcludedOnOldRegister"] = 32] = "LotbaUserSelfExcludedOnOldRegister";
    Topic[Topic["GameTransaction"] = 33] = "GameTransaction";
    Topic[Topic["BalanceChangedCoreX"] = 34] = "BalanceChangedCoreX";
    Topic[Topic["UserProfileUpdatedCoreX"] = 35] = "UserProfileUpdatedCoreX";
    Topic[Topic["RealityCheckUpdatedX"] = 36] = "RealityCheckUpdatedX";
    Topic[Topic["VerificationDocumentsUpdatedX"] = 37] = "VerificationDocumentsUpdatedX";
    Topic[Topic["SessionDestroyedCoreX"] = 38] = "SessionDestroyedCoreX";
})(Topic = exports.Topic || (exports.Topic = {}));
var PubSub = /** @class */ (function () {
    function PubSub() {
        this.id = 0;
        this.topics = {};
    }
    PubSub.prototype.subscribe = function (topic, handler) {
        var _this = this;
        if (!this.topics[topic]) {
            this.topics[topic] = [];
        }
        var id = (++this.id).toString();
        var unsub = function () { return _this.unsubscribe(id); };
        this.topics[topic].push({ id: id, handler: handler });
        return { id: id, unsub: unsub };
    };
    PubSub.prototype.publish = function (topic, params) {
        if (!this.topics[topic]) {
            return false;
        }
        this.topics[topic].forEach(function (subscriber) {
            subscriber.handler(params);
        });
        return true;
    };
    PubSub.prototype.unsubscribe = function (id) {
        for (var key in this.topics) {
            if (!this.topics.hasOwnProperty(key)) {
                continue;
            }
            var topic = key;
            if (Array.isArray(this.topics[topic])) {
                for (var i = 0; i < this.topics[topic].length; i++) {
                    if (this.topics[topic][i].id === id) {
                        this.topics[topic].splice(i, 1);
                        return true;
                    }
                }
            }
        }
        return false;
    };
    return PubSub;
}());
exports.pubsub = new PubSub();
